var React = require('react');

function inlineSvg (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 9.04261L5.68217 14.1524L16.2194 0.847656","stroke":"#FCFEFF","strokeWidth":"2"}));
}

inlineSvg.defaultProps = {"width":"18","height":"16","viewBox":"0 0 18 16","fill":"none","className":"inline-svg"};

module.exports = inlineSvg;

inlineSvg.default = inlineSvg;
